import { render, staticRenderFns } from "./lease.vue?vue&type=template&id=65ea3f20&scoped=true"
import script from "./lease.vue?vue&type=script&lang=js"
export * from "./lease.vue?vue&type=script&lang=js"
import style0 from "./lease.vue?vue&type=style&index=0&id=65ea3f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea3f20",
  null
  
)

export default component.exports